<template>
  <div id="thehub_plans">
    <div
      ref="mainContainerMonetise"
      :class="
        !isMounted
          ? 'monetise-options'
          : width > widthBreak
          ? 'monetise-options'
          : 'monetise-options_thin'
      "
    >
      <div v-for="plan in parsedItems" :key="plan.id" :class="getCardClass(parsedItems.length)">
        <div
          :ref="`plan-${plan.id}`"
          :class="
            !plan.isHighlighted
              ? 'monetise-options-option_card'
              : 'monetise-options-option_card_highlited'
          "
        >
          <div v-if="plan.isHighlighted" class="monetise-options-highlighted_header">
            <!-- :style="`width:${cardWidth}px`" -->
            <div class="monetise-options-highlighted_header-title">{{ plan.cost }} IF YOU HIRE</div>
            <img src="/monetise/tag.svg" style="margin-right: 1.5rem;" />
          </div>
          <div v-if="plan.isLiteHighlighted" class="monetise-options-highlighted_header">
            <!-- :style="`width:${cardWidth}px`" -->
            <div class="monetise-options-litehighlighted_header-title">
              Dedicated Recruiter Included
            </div>
            <img src="/monetise/tag_blue.svg" style="margin-right: 1.5rem;" />
          </div>
          <div class="monetise-options-option_card-title">
            {{ plan.label }}
          </div>
          <div v-if="plan.isHighlighted" class="monetise-options-option_card-cost">
            <div class="monetise-options-option_card-cost-value">0,- {{ plan.currency }}</div>

            <div style="font-weight: 400; width: 75px;">now</div>
          </div>
          <div v-else class="monetise-options-option_card-cost">
            <div class="monetise-options-option_card-cost-value">{{ plan.cost }}</div>
            <div
              v-if="plan.discount > 0"
              style="width: 75px;"
              class="monetise-options-option_card-cost-discount"
            >
              <div>{{ plan.discount }}%</div>
              <div class="ml-4">OFF</div>
            </div>
            <div
              v-else-if="plan.banner"
              style="width: 75px;"
              class="monetise-options-option_card-cost-discount"
            >
              <div>{{ plan.banner }}</div>
            </div>
            <div v-else style="width: 75px; color: rgba(0,0,0,0);">
              /
            </div>
          </div>
          <!-- :style="
            !plan.isFree ? '' : 'opacity: 0; cursor: default; user-select: none'
          " -->
          <div
            :class="
              !plan.isFree
                ? 'monetise-options-option_card-target'
                : 'monetise-options-option_card-custom_target'
            "
          >
            {{ plan.target }}
          </div>
          <div
            :style="!plan.isFree ? '' : 'opacity: 0; cursor: default; user-select: none'"
            class="monetise-options-option_card-target_description"
          >
            <div v-html="plan.targetDescription"></div>
          </div>
          <button
            :class="
              selectedPlanID === plan.id
                ? 'monetise-options-option_card-select_button_selected'
                : 'monetise-options-option_card-select_button'
            "
            @click="handleClick(plan)"
          >
            {{
              showCustomButtonTitle
                ? plan.selectButtonText
                : selectedPlanID === plan.id
                ? 'Selected'
                : 'Select'
            }}
            <img
              v-if="selectedPlanID === plan.id"
              src="/monetise/white_check.svg"
              class="monetise-options-option_card-select_button-check"
            />
          </button>
          <div v-if="showExploreLink">
            <!-- v-if="plan.title !== 'FREE'" -->
            <a
              :href="plan.exploreUrl"
              target="_blank"
              :class="
                !plan.isHighlighted
                  ? 'monetise-options-option_card-exprole_link'
                  : 'monetise-options-option_card-exprole_link-alter'
              "
            >
              {{ plan.exploreLinkTitle }}
            </a>
            <!-- <div
            v-else
            style="opacity: 0; cursor: default; user-select: none"
            class="monetise-options-option_card-exprole_link"
          >
            {{ plan.exploreLinkTitle }}
          </div> -->
          </div>
        </div>
        <div>
          <div
            v-for="feature in parsedFeatures"
            :key="feature.id"
            class="monetise-options-features"
          >
            <div v-if="plan.features.includes(feature.id)">
              <div
                :ref="feature.id + plan.id"
                class="monetise-options-features-feature"
                @click="toggleFeature(feature.id, plan.id)"
              >
                <img :src="feature.icon" class="monetise-options-features-feature-icon" />
                <div class="monetise-options-features-feature-title">
                  {{ feature.title }}
                </div>
                <img
                  :src="
                    plan.openFeatures.includes(feature.id)
                      ? '/monetise/arrow_up.svg'
                      : '/monetise/arrow_down.svg'
                  "
                />
              </div>
              <div v-if="plan.openFeatures.includes(feature.id)">
                <div v-for="point in feature.points" :key="point">
                  <div
                    v-if="point === 'Duration:'"
                    class="monetise-options-features-feature-duration_point"
                  >
                    <img src="/monetise/check_mark.svg" />
                    <div class="monetise-options-features-feature-duration_point-text">
                      {{ point }}
                      <div style="width: 0.3rem;"></div>
                      <div
                        :style="{
                          fontWeight: 'bold',
                          color: !plan.isFree ? '#443FDB' : '#443FDB'
                        }"
                      >
                        {{ plan.duration }}
                      </div>
                    </div>
                  </div>
                  <div v-else class="monetise-options-features-feature-point">
                    <img src="/monetise/check_mark.svg" />
                    <div style="margin-left: 0.4rem">
                      <div v-html="point"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="monetise-options-features-disabled_feature">
                <img src="/monetise/cross_mark.svg" />
                <div class="monetise-options-features-disabled_feature-title">
                  {{ feature.title }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="plan.isHighlighted && showHighlightedFooter"
            class="monetise-options-highlighted_footer"
          >
            <img src="/monetise/check_icon.svg" />
            <div class="monetise-options-highlighted_footer-title">
              GUARANTEED HIRE
            </div>
            <div class="monetise-options-highlighted_footer-text">
              No cure, no pay. Get started for free and only pay if you successfully hire a
              candidate for the position.
            </div>
          </div>
        </div>
      </div>
    </div>

    <Tooltip
      v-if="!!items.find((plan) => plan.title === 'HEADHUNTER') && shouldDisplayTooltip"
      :icon="require('@/assets/components/plans/success.svg')"
      :color="`#24cf94`"
      :source="source"
    >
      <template v-slot:default>
        Do you want to <b>pay 0 upfront</b> and only pay <b>if you hire?</b>
        <b
          class="custom-tooltip-extra_content"
          style="cursor: pointer; color:#443fdb"
          @click="handleCustomToogleAction"
          >Explore Scout</b
        >, our brand new AI-powered headhunting service for startups.

        <!-- <b>Pay 0</b> upfront – only pay if you hire.
        <b
          class="custom-tooltip-extra_content"
          style="cursor: pointer;"
          @click="handleCustomToogleAction"
          >Try Scout</b
        >, the AI-powered headhunter for startups. -->
      </template>
    </Tooltip>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import Tooltip from './Tooltip.vue';
export default {
  components: { Tooltip },
  name: 'Plans',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    features: {
      type: Array,
      default: () => []
    },
    parentClickHandler: {
      type: Function,
      default: () => {}
    },
    preSelectedPlanID: {
      type: String,
      default: ''
    },
    showHighlightedFooter: {
      type: Boolean,
      default: true
    },
    showCustomButtonTitle: {
      type: Boolean,
      default: true
    },
    showExploreLink: {
      type: Boolean,
      default: true
    },
    shouldFeaturesBeOpenByDefault: {
      type: Boolean,
      default: false
    },
    shouldDisplayTooltip: {
      type: Boolean,
      required: false,
      default: false
    },
    onNext: {
      type: Function,
      required: false,
      default: async () => {}
    },
    source: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return { tempSelectedPlanID: '', width: 0, cardWidth: 0, widthBreak: 650 };
  },
  computed: {
    parsedItems() {
      return this.shouldDisplayTooltip
        ? this.items.filter((plan) => plan.title !== 'HEADHUNTER')
        : this.items.filter((plan) => plan.title !== 'HEADHUNTER');
    },
    parsedFeatures() {
      const items = this.items || [];
      let features = this.features || [];
      features = features.filter((feature) => feature.id !== 'headhunter');

      // console.log('features', features);

      const availableFeatures = items
        .map((plan) => {
          if (plan.title === 'FREE' || plan.title === 'BASIC') return 'publishing';
          if (plan.title === 'PRO') return 'promotion';
          if (plan.title === 'MAX') return 'max';
          if (plan.title === 'HEADHUNTER') return 'headhunter';
        })
        .filter((plan) => plan);
      return features.filter((feature) => availableFeatures.includes(feature.id));
    },
    selectedPlanID() {
      return this.tempSelectedPlanID || this.preSelectedPlanID;
    }
  },
  watch: {},
  mounted() {
    this.startResizingObserver();
  },
  methods: {
    startResizingObserver() {
      setTimeout(() => {
        this.onResize = () => {
          let mainContainerMonetise = this.$refs.mainContainerMonetise;
          this.width = mainContainerMonetise?.offsetWidth;
          //   console.log('width', this.width)
          this.$emit('resize', mainContainerMonetise?.offsetHeight);
        };
        this.ro = new ResizeObserver(this.onResize);
        let mainContainerMonetise = this.$refs.mainContainerMonetise;
        this.ro.observe(mainContainerMonetise);
        if (!this.isMounted) {
          this.isMounted = true;
        }
      }, 800);

      if (this.items[0] && this.items[0].id) {
        setTimeout(() => {
          // console.log('this.$refs', this.$refs);
          // console.log('this.$refs 1', `plan-${this.items[0].id}`);
          // console.log('this.$refs 2', this.$refs[`plan-${this.items[0].id}`][0]);
          this.onCardResize = () => {
            let planCard = this.$refs[`plan-${this.items[0].id}`][0];
            this.cardWidth = planCard?.offsetWidth;
            //   console.log('width', this.width)
            this.$emit('resize', planCard?.offsetHeight);
          };
          this.cardRO = new ResizeObserver(this.onCardResize);
          let planCard = this.$refs[`plan-${this.items[0].id}`][0];
          this.cardRO.observe(planCard);
          // if (!this.isMounted) {
          //   this.isMounted = true;
          // }
        }, 800);
      }
    },
    getCardClass(length) {
      if (!this.isMounted) {
        return `card-1to1${this.width < this.widthBreak ? '_thin' : ''}`;
      }
      switch (length) {
        case 1:
          return `card-1to1${this.width < this.widthBreak ? '_thin' : ''}`;
        case 2:
          return `card-1to2${this.width < this.widthBreak ? '_thin' : ''}`;
        case 3:
          return `card-1to3${this.width < this.widthBreak ? '_thin' : ''}`;
        case 4:
          return `card-1to4${this.width < this.widthBreak ? '_thin' : ''}`;
        case 5:
          return `card-1to5${this.width < this.widthBreak ? '_thin' : ''}`;
        case 6:
          return `card-1to6${this.width < this.widthBreak ? '_thin' : ''}`;
        default:
          return `card-1to1${this.width < this.widthBreak ? '_thin' : ''}`;
      }
    },
    handleClick: function(plan) {
      this.parentClickHandler(plan, () => {
        this.tempSelectedPlanID = plan.id;
      });
    },
    async handleCustomToogleAction() {
      const plans = this.items || [];
      const HHplan = plans.find((plan) => plan.title === 'HEADHUNTER');
      if (HHplan) {
        this.parentClickHandler(HHplan, () => {
          this.tempSelectedPlanID = HHplan.id;
        });

        setTimeout(async () => {
          await this.onNext();
        }, 200);
      }
    },
    toggleFeature: function(featureID, planID) {
      let plans = JSON.parse(JSON.stringify(this.items));
      for (let index = 0; index < plans.length; index++) {
        if (planID === plans[index].id) {
          let plan = plans[index];
          let openFeatures = [...plan.openFeatures];
          if (!openFeatures.includes(featureID)) {
            openFeatures.push(featureID);
            this.$refs[featureID + planID][0].scrollIntoView({
              block: 'center',
              behavior: 'smooth'
            });
          } else {
            openFeatures = openFeatures.filter((feature) => feature !== featureID);
          }
          plan.openFeatures = openFeatures;
          plans[index] = plan;
          this.items = [...plans];
          break;
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.plans_wrapper {
  position: relative;
  width: 100%;
}

.custom-tooltip-extra_content {
  &:hover {
    text-decoration: underline;
    color: #443fdb;
  }
}

.card-1to1 {
  width: 100%;
}
.card-1to2 {
  width: 50%;
  margin-bottom: 2.5rem;
  // @include media-breakpoint-down(sm) {
  //   width: 100%;
  //   &:last-of-type {
  //     margin-top: 3rem;
  //   }
  // }
}
.card-1to3 {
  width: 33.3333333%;
  margin-bottom: 2.5rem;
  // @include media-breakpoint-down(sm) {
  //   width: 100%;
  //   &:last-of-type {
  //     margin-top: 3rem;
  //   }
  // }
}
.card-1to4 {
  width: 25%;
  margin-bottom: 2.5rem;
  // @include media-breakpoint-down(sm) {
  //   width: 100%;
  //   &:last-of-type {
  //     margin-top: 3rem;
  //   }
  // }
}
.card-1to5 {
  width: 20%;
  margin-bottom: 2.5rem;
  // @include media-breakpoint-down(sm) {
  //   width: 100%;
  //   &:last-of-type {
  //     margin-top: 3rem;
  //   }
  // }
}
.card-1to6 {
  width: 16.666666%;
  margin-bottom: 2.5rem;
  // @include media-breakpoint-down(sm) {
  //   width: 100%;
  //   &:last-of-type {
  //     margin-top: 3rem;
  //   }
  // }
}
.card-1to1_thin {
  width: 100%;
}
.card-1to2_thin {
  margin-bottom: 2.5rem;
  width: 100%;
  &:last-of-type {
    margin-top: 3rem;
  }
}
.card-1to3_thin {
  margin-bottom: 2.5rem;
  width: 100%;
  &:last-of-type {
    margin-top: 3rem;
  }
}
.card-1to4_thin {
  margin-bottom: 2.5rem;
  width: 100%;
  &:last-of-type {
    margin-top: 3rem;
  }
}
.card-1to5_thin {
  margin-bottom: 2.5rem;
  width: 100%;
  &:last-of-type {
    margin-top: 3rem;
  }
}
.card-1to6_thin {
  margin-bottom: 2.5rem;
  width: 100%;
  &:last-of-type {
    margin-top: 3rem;
  }
}
.monetise {
  //
  display: flex;
  width: 100%;
}
.monetise-preview {
  flex: 1;
  margin: 0px 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.monetise-preview-job_title {
  color: #1f2430;
  font-size: 1.2rem;
  font-weight: 700;
}
.monetise-preview-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.monetise-preview-detail-title {
  color: #51596c;
  font-weight: 400;
}
.monetise-preview-detail-value {
  color: #1f2430;
  font-weight: 500;
}
.monetise-preview-detail-description {
  width: 100%;
  align-items: flex-start;
}
.monetise-preview-startup_logo {
  width: 4rem;
  margin: 1.5rem;
}
.monetise-preview-expand {
  position: absolute;
  top: 0px;
  right: 0px;
  cursor: pointer;
  width: 3rem;
}
.monetise-preview-live_preview {
  color: #818795;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vertical_br {
  width: 1px;
  background-color: #e8e9ea;
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.horizontal_br {
  height: 1px;
  width: 100%;
  background-color: #e8e9ea;
  margin: 1rem 0px;
}
.faq_container {
  // background-color: #f5f7fa;
}
.monetise-head-descriptiom {
  margin-top: 1rem;
  font-size: 1.25rem;
  width: 90%;
}
.monetise-options {
  display: flex;
  width: 100%;
  justify-content: space-between;
  // @include media-breakpoint-down(sm) {
  //   flex-direction: column;
  // }
}
.monetise-options_thin {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
}
.monetise-options-option_card {
  // border: 1px 1px 0px 1px;
  // border-style: solid;
  // border-color: #d5d6d9;
  margin-top: 1px;
  margin-left: 1px;
  outline: 1px solid #d5d6d9;
  padding: 1.5rem;
  color: #1f2430;
  position: relative;
}
.monetise-options-option_card_highlited {
  background-color: #443fdb;
  margin-top: 1px;
  margin-left: 1px;
  outline: 1px solid #d5d6d9;
  padding: 1.5rem;
  color: white;
  position: relative;
  .monetise-options-option_card-target_description {
    color: white;
  }
  .monetise-options-option_card-select_button_selected {
    border: 1px solid #24cf94;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.2rem;
    width: 100%;
    padding: 1rem !important;
    background-color: #24cf94;
    color: white;
  }
}
.monetise-options-option_card-title {
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
}
.monetise-options-option_card-cost {
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  min-height: 2rem;
  // width: 100%;
}
.monetise-options-option_card-cost-value {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 0.75rem;
  // height: 1.75rem;
  // width: 70%;
}
.monetise-options-option_card-cost-discount {
  display: flex;
  background-color: #f81f41;
  color: white;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  padding: 0 0.5rem;
}
.monetise-options-option_card-target {
  font-weight: 700;
  font-size: 3rem;
  line-height: 4rem;
  height: 4rem;
}
.monetise-options-option_card-custom_target {
  font-weight: 700;
  font-size: 1rem;
  line-height: 2.2rem;
  margin: 0.9rem 0;
  background-color: #ffede6;
  color: #fa8557;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60%;
  min-width: 157px;
}
.monetise-options-option_card-target_description {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1rem;
  color: #818795;
  margin-bottom: 2rem;
  height: 1rem;
}
.monetise-options-option_card-select_button {
  border: 1px solid #d5d6d9;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.2rem;
  width: 100%;
  padding: 1rem !important;
  background-color: white;
  &:hover {
    color: #443fdb;
    border-color: #b8bbc2;
  }
}
.monetise-options-option_card-select_button_selected {
  border: 1px solid #443fdb;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.2rem;
  width: 100%;
  padding: 1rem !important;
  background-color: #443fdb;
  color: white;
}
.monetise-options-features {
  // border: 1px 1px 0px 1px;
  // border-style: solid;
  // border-color: #d5d6d9;
  margin-top: 1px;
  margin-left: 1px;
  outline: 1px solid #d5d6d9;
}
.monetise-options-features-feature {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
  // margin-bottom: 1.25rem;
  cursor: pointer;
}
.monetise-options-features-feature-title {
  font-weight: 400;
  font-size: 0.81rem;
  line-height: 1.5rem;
  color: #1f2430;
  margin: 0px 0.5rem;
}
.monetise-options-features-feature-duration_point {
  padding: 0px 1rem 0.75rem 1rem;
  font-weight: 400;
  font-size: 0.83rem;
  line-height: 1.2rem;
  color: #818795;
  display: flex;
  align-items: baseline;
}
.monetise-options-features-feature-duration_point-text {
  margin-left: 0.4rem;
  display: flex;
}
.monetise-options-features-feature-point {
  padding: 0px 1rem 0.75rem 1rem;
  font-weight: 400;
  font-size: 0.83rem;
  line-height: 1.2rem;
  color: #818795;
  display: flex;
  align-items: baseline;
}
.monetise-options-features-feature-icon {
  height: 1.5rem;
  width: 1.5rem;
}
.monetise-options-features-disabled_feature {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  padding: 0.75rem;
  color: rgba(31, 36, 48, 0.5);
}
.monetise-options-features-disabled_feature-title {
  font-weight: 400;
  font-size: 0.81rem;
  line-height: 1.5rem;
  margin: 0px 0.5rem;
}
.monetise-options-highlighted_header {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: absolute;
  top: -3.03rem;
  left: 0px;
  width: -webkit-fill-available;
  width: -moz-available;
  // width: fill-available;
  width: stretch;
}
.monetise-options-highlighted_header-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #24cf94;
  font-weight: 700;
  font-size: 0.9rem;
  line-height: 1.4rem;
  // padding: 0.75rem;
  height: 2.9rem;
  margin-top: 1px;
  margin-left: 1px;
  outline: 1px solid #24cf94;
}
.monetise-options-highlighted_footer {
  background-color: #24cf94;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  text-align: center;
  margin-top: 1px;
  margin-left: 1px;
  outline: 1px solid #24cf94;
}
.monetise-options-litehighlighted_header-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #443fdb;
  color: white;
  font-weight: 700;
  font-size: 0.9rem;
  line-height: 1.4rem;
  // padding: 0.75rem;
  height: 2.9rem;
  margin-top: 1px;
  margin-left: 1px;
  outline: 1px solid #443fdb;
}
.monetise-options-litehighlighted_footer {
  background-color: #443fdb;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  text-align: center;
  margin-top: 1px;
  margin-left: 1px;
  outline: 1px solid #443fdb;
}
.monetise-options-highlighted_footer-title {
  font-size: 1rem;
  line-height: 1.4rem;
  font-weight: 700;
  margin-top: 0.5rem;
  margin-bottom: 0.2rem;
}
.monetise-options-highlighted_footer-text {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
}
.monetise-options-option_card-select_button-check {
  margin: 0px 0px 0px 1rem;
  margin-bottom: 0.2rem;
}
.monetise-spinner_wrapper {
  width: 100%;
  height: calc(100vh - 10rem);
  display: flex;
  align-items: center;
  justify-content: center;
}
.monetise-options-option_card-exprole_link {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  font-weight: 400;
  color: #443fdb;
  text-transform: capitalize;
  // &:hover {
  // font-weight: 800;
  // }
}
.monetise-options-option_card-exprole_link-alter {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  font-weight: 400;
  color: white;
  text-transform: capitalize;
  // &:hover {
  // font-weight: 800;
  // }
}
</style>
